import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { SearchFacet, SearchFilters, SearchFilterValue } from '../../model';
import { SEARCH_TEST_ID } from '../../test/test-ids';
import { FacetsPanel } from '../FacetsPanel/FacetsPanel';
import { Facets } from './Facets';

type Props = {
    facets: SearchFacet[];
    filters: SearchFilters;
    onChange: (fieldName: string, filter: SearchFilterValue) => void;
};

export const ProductsFacetsPanel: FC<Props> = ({ facets, filters, onChange }) => {
    const { t } = useTranslations();

    return (
        <FacetsPanel
            dataTest={SEARCH_TEST_ID.RESULTS_PRODUCTS_FACETS_PANEL}
            ariaLabel={t['search.component.facets_drawer.heading']}
        >
            <Facets facets={facets} filters={filters} showCount={true} onChange={onChange} />
        </FacetsPanel>
    );
};
